import firebase from 'firebase/app'
import * as React from 'react'

export const AuthUsetContext: React.Context<firebase.User | null> = React.createContext<firebase.User | null>(
  null
)



// WEBPACK FOOTER //
// ./src/components/Session/context.ts